import Vue from 'vue'
import Product from './Product.vue'
import '@/assets/common/css/common.less'
import '@/plugins/fontsLoader'

Vue.config.productionTip = false

new Vue({
  render: (h) => h(Product)
}).$mount('#Product')
